import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  async copy() {
    await navigator.clipboard.writeText(this.urlValue)
    const original = this.element.textContent
    this.element.textContent = "Copied"
    window.setTimeout(() => {
      this.element.textContent = original
    }, 1500)
  }
}
